module.exports = leftpad;

function leftpad (str, len, ch) {
  str = String(str);

  var i = -1;

  if (!ch && ch !== 0) ch = ' ';

  len = len - str.length;

  while (++i < len) {
    str = ch + str;
  }

  return str;
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/left-pad/index.js
 ** module id = 42
 ** module chunks = 0
 **/